"use client";

import { useInteractionStore, InteractionState } from "@/stores/search/interaction-store";
import { useLocationsStore } from "@/stores/search/locations-store";
import { useMapDataStore, MapDataState } from "@/stores/search/map-store";

// ---------------------------------------------------------------------------
// MapData store hooks
// ---------------------------------------------------------------------------

/** Select a slice of MapDataState with automatic re-render on change. */
export function useSearchPageMapData(selector) {
  return useMapDataStore(selector);
}

// ---------------------------------------------------------------------------
// Interaction store hooks
// ---------------------------------------------------------------------------

/** Select a slice of InteractionState with automatic re-render on change. */
export function useSearchPageInteraction(selector) {
  return useInteractionStore(selector);
}

/**
 * Access the raw interaction store for imperative `.getState()` / `.subscribe()` calls.
 * Prefer `useSearchPageInteraction(selector)` in render paths.
 *
 * @deprecated Import `useInteractionStore` directly from `@/stores/search/interaction-store` instead.
 */
export function useSearchPageInteractionStore(): typeof useInteractionStore {
  return useInteractionStore;
}

// ---------------------------------------------------------------------------
// Locations store hooks
// ---------------------------------------------------------------------------

/**
 * Access the raw locations store for imperative `.getState()` / `.subscribe()` calls.
 * Prefer importing `useLocationsStore` directly from `@/stores/search/locations-store`.
 *
 * @deprecated Import `useLocationsStore` directly from `@/stores/search/locations-store` instead.
 */
export function useSearchPageLocationsStore(): typeof useLocationsStore {
  return useLocationsStore;
}